var $ = require('js/sw-jquery/sw-jquery');

/**
 * Instantiates PaginationView's from fragments
 */
module.exports = function($fragment) {

    $fragment.swFindWithSelf('[data-sw-pagination]').each(function() {
        var $el = $(this);

        require(['js/lib/views/Pagination'], function(PaginationView) {
            new PaginationView({
                el: $el
            });

        });
    });

};
